import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type VarianteBoton = 'primario' | 'secundario' | 'peligro' | 'fantasma';
export type TamanoBoton = 'normal' | 'grande';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: VarianteBoton;
  tamano?: TamanoBoton;
  /** Ocupa todo el ancho disponible. Predeterminado en pantallas de telefono. */
  completo?: boolean;
  children: ReactNode;
}

const VARIANTES: Record<VarianteBoton, string> = {
  primario: 'bg-marca text-white active:bg-marca-fuerte disabled:bg-borde-fuerte',
  secundario:
    'bg-superficie text-texto border border-borde-fuerte active:bg-superficie-suave disabled:text-texto-tenue',
  peligro: 'bg-alerta text-white active:brightness-90 disabled:bg-borde-fuerte',
  fantasma: 'bg-transparent text-marca active:bg-marca-suave disabled:text-texto-tenue',
};

const TAMANOS: Record<TamanoBoton, string> = {
  // Area tactil minima de 44x44 puntos (Req. 19.2)
  normal: 'min-h-11 px-4 py-2.5 text-base',
  grande: 'min-h-14 px-5 py-3.5 text-lg',
};

/**
 * Boton base de la aplicacion.
 *
 * El tamano minimo no es decorativo: cumple el area tactil de 44x44 puntos que
 * pide el Requisito 19.2, pensada para usarse con el pulgar en la cocina.
 */
export function Button({
  variante = 'primario',
  tamano = 'normal',
  completo = true,
  className = '',
  type = 'button',
  children,
  ...resto
}: Props) {
  return (
    <button
      type={type}
      className={[
        'inline-flex items-center justify-center gap-2 rounded-xl font-medium',
        'transition-colors select-none',
        'disabled:cursor-not-allowed disabled:opacity-70',
        VARIANTES[variante],
        TAMANOS[tamano],
        completo ? 'w-full' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...resto}
    >
      {children}
    </button>
  );
}
